export default "__VITE_ASSET__DCd_02fi__"